'use strict';

angular.module('jotApp')
    .directive('setminheight', function ($window) {
        return {
            link: function (scope, element, attrs) {
                // header height
                var topOffset = 50;
                // footer height
                var bottomOffset = 33;
                element.css('min-height', ($window.innerHeight - topOffset - bottomOffset  ) + 'px');
                $(window).on("resize", function(){
                    element.css('min-height', ($window.innerHeight - topOffset - bottomOffset  ) + 'px');
                });
            }
        };
    });

